import PropTypes from 'prop-types';

export default PropTypes.shape({
  isLoaded: PropTypes.bool,
  isEmpty: PropTypes.bool,
  avatarUrl: PropTypes.string,
  displayName: PropTypes.string,
  email: PropTypes.string,
});



// WEBPACK FOOTER //
// ./src/proptypes/profile.js